import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Card } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  selectBillingsList,
  selectBillingsListCount,
  selectBillingsQueryOptions
} from 'src/store/selectors/billingSelector';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import { loadBillings, LOAD_BILLING } from 'src/store/actions/billingActions';
import Toolbar from './Toolbar';
import BillingTable from './BillingTable';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const BillingList = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const billings = useSelector(selectBillingsList);
  const count = useSelector(selectBillingsListCount);
  const { page } = useSelector(selectBillingsQueryOptions);
  const loading = useSelector(isLoadingSelector([LOAD_BILLING.action]));
  const success = useSelector(successSelector([LOAD_BILLING.action]));

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadBillings({ page: value }));
    },
    [dispatch]
  );

  if (success && !loading && count === 0) {
    return (
      <Card className={classes.prealoderCard}>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.BILLING_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.BILLING_DESCRIPTION"
        />
      </Card>
    );
  }

  return (
    <BillingTable
      billings={billings}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

const BillingListView = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={t('NAVIGATION.BILLING')}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            <BillingList />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

export default BillingListView;
